import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Typography, Checkbox, FormControlLabel, Divider, Tooltip, IconButton } from "@mui/material";
import React, { useState, useEffect } from "react";
import { uppercaseFirst } from "../utils";

import SearchIcon from '@mui/icons-material/Search';
import SearchOffIcon from '@mui/icons-material/SearchOff';
import { colorTextInactive } from "../App/theme";
import { searchProps, searchTypes } from "./contants";

function propToType(str) {
    return str.replace(/\d+$/, '');
}

function parseAttrName(attrName) {
    const units = ['_g', '_mg', '_µg', '_kcal', '_mmol'];
    let unit = '';

    for (let i = 0; i < units.length; i++) {
        if (attrName.endsWith(units[i])) {
            unit = units[i].substring(1); // Remove the underscore
            attrName = attrName.slice(0, -units[i].length);
            break;
        }
    }

    return {
        parsedAttrName: attrName,
        parsedUnit: unit
    };
}

export const CreateAttribute = ({ newAttribute, setNewAttribute, handleDialogClose, dialogOpen, handleDialogSave, itemTypeToCreate, existingAttributes }) => {
    const [error, setError] = useState('');

    useEffect(() => {
        if (dialogOpen) {
            const searchType = searchTypes.find(type => type.type === propToType(dialogOpen));

            if (searchType) {
                setNewAttribute(prev => ({
                    ...prev,
                    encrypted: searchType.encrypted,
                    semanticSearch: searchType.semanticSearch || false
                }));
            }
        }
    }, [dialogOpen]);

    if (!newAttribute || !newAttribute.attrType) return null;

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            handleSave();
        }
    };

    const handleSave = () => {
        if (existingAttributes.find(o => o?.attrName === newAttribute.attrName)) {
            setError('Attribute name already exists.');
        } else {
            setError('');
            handleDialogSave();
        }
    };

    const handleCheckboxChange = (field) => (event) => {
        setNewAttribute({ ...newAttribute, [field]: event.target.checked });
    };

    const searchType = searchTypes.find(type => type.type === propToType(dialogOpen));

    return (
        <Dialog open={!!dialogOpen} onClose={handleDialogClose}>
            <DialogTitle>New Attribute</DialogTitle>
            <DialogContent>
                <TextField
                    required={true}
                    autoFocus
                    margin="dense"
                    label="Attribute Name"
                    type="text"
                    fullWidth
                    value={newAttribute.attrName || ''}
                    onChange={(e) => {
                        let val = e.target.value;
                        let unit = newAttribute?.unit;

                        const {parsedAttrName, parsedUnit} = parseAttrName(val)

                        if (parsedUnit) unit = parsedUnit;

                        setNewAttribute({
                            ...newAttribute,
                            attrName: parsedAttrName,
                            label: uppercaseFirst(parsedAttrName.replace('_', ' ')),
                            placeholder: 'Enter' + (itemTypeToCreate
                                ? (' ' + itemTypeToCreate.toLowerCase() + ' ')
                                : ' ') + parsedAttrName.replace('_', ' '),
                            unit,
                        });
                        setError('');
                    }}
                    onKeyDown={handleKeyDown}
                    error={!!error}
                    helperText={error}
                />

                <Divider sx={{ mt: 4, mb: 4 }}>Optional Settings</Divider>

                {newAttribute?.attrType !== 'itemId' && <Tooltip title={newAttribute.semanticSearch
                    ? "Included in the embedding template."
                    : "Not included in the embedding template."}>
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={newAttribute.semanticSearch || false}
                                onChange={handleCheckboxChange('semanticSearch')}
                            />
                        }
                        label={
                            <Typography>
                                Semantic Search
                            </Typography>
                        }
                    />
                </Tooltip>}

                {newAttribute?.attrType !== 'itemId' && <>
                    <Tooltip title={newAttribute.encrypted
                        ? "Stored encrypted with your personal AES key"
                        : "Stored in plain text"}>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={newAttribute.encrypted || false}
                                    onChange={handleCheckboxChange('encrypted')}
                                />
                            }
                            label={"Encrypted"}
                        />
                    </Tooltip>

                    {/*<Tooltip title={newAttribute?.encrypted*/}
                    {/*    ? "Structured search is not available for encrypted fields."*/}
                    {/*    : `Searchable as ${searchProps[newAttribute?.attrType]?.type}`} >*/}
                    {/*<span>*/}
                    {/*    <FormControlLabel*/}
                    {/*        control={*/}
                    {/*            <Checkbox*/}
                    {/*                icon={<SearchOffIcon style={{color: colorTextInactive}} />}*/}
                    {/*                checkedIcon={<SearchIcon />}*/}
                    {/*                checked={!newAttribute.encrypted}*/}
                    {/*                onChange={handleCheckboxChange('structuredSearch')}*/}
                    {/*                disabled={newAttribute.encrypted}*/}
                    {/*            />*/}
                    {/*        }*/}
                    {/*        label="Structured Search"*/}
                    {/*    />*/}
                    {/*</span>*/}
                    {/*</Tooltip>*/}
                </>}

                <TextField
                    margin="dense"
                    label="Unit"
                    type="text"
                    fullWidth
                    value={newAttribute.unit || ''}
                    onChange={(e) => setNewAttribute({ ...newAttribute, unit: e.target.value })}
                    onKeyDown={handleKeyDown}
                />

                <TextField
                    margin="dense"
                    label="Input Label"
                    type="text"
                    fullWidth
                    value={newAttribute.label || ''}
                    onChange={(e) => setNewAttribute({ ...newAttribute, label: e.target.value })}
                    onKeyDown={handleKeyDown}
                />
                <TextField
                    margin="dense"
                    label="Input Placeholder"
                    type="text"
                    fullWidth
                    value={newAttribute.placeholder || ''}
                    onChange={(e) => setNewAttribute({ ...newAttribute, placeholder: e.target.value })}
                    onKeyDown={handleKeyDown}
                />
                <TextField
                    disabled={true}
                    margin="dense"
                    label="Type"
                    type="text"
                    fullWidth
                    value={propToType(newAttribute.attrType) || ''}
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={() => handleDialogClose(true)} color="primary">
                    Cancel
                </Button>
                <Button disabled={!newAttribute?.attrName} onClick={handleSave} color="primary">
                    Add
                </Button>
            </DialogActions>
        </Dialog>
    );
};